import { useState } from 'react';
import style from './CategoryButtons.module.css';


const BrandsCategoryButtons2 = ({ brands , onCategorySelect , vertical , setFilteredBrands }) => {
    // 선택된 카테고리 상태 관리
    const [selectedBrandsCategory, setSelectedBrandsCategory] = useState(null);

    const brandTypeMap = {
        LIQUID: '액상',
        DISPOSABLEDEVICE: '일회용',
        DEVICE: '기기',
        // 더 추가할 수 있음
        null: '기타',  // brandType이 null인 경우 처리
    };

    const uniqueBrandTypes = brands ? [...new Set(brands.map(brand => brand.brandType))].filter(type => type !== null) : [];
    const productCategories = uniqueBrandTypes.map(type => brandTypeMap[type] || type);

    const handleCategoryClick = (category) => {
        if(category === selectedBrandsCategory){
            setSelectedBrandsCategory(null)
            setFilteredBrands(brands)
        }
        else{
            setSelectedBrandsCategory(category);  // 선택된 카테고리 업데이트
            onCategorySelect(category);     // 부모 컴포넌트로 선택한 카테고리 전달
        }
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', position: 'relative', padding:"20px 50px" }}>
            {productCategories.map((category, index) => (
                <button
                    className={style.btn}
                    key={category}
                    onPointerUp={() => handleCategoryClick(category)}  // 클릭 시 카테고리 전달 및 상태 업데이트
                    style={{
                        width: "18.95%",
                        maxWidth: "18.95%",
                        height: vertical === true ? "44px": "53px",
                        padding: '8px 18px',
                        backgroundColor: selectedBrandsCategory === category ? '#FE531F' : 'white',  // 선택된 버튼은 배경색 변경
                        color: selectedBrandsCategory === category ? 'white' : 'black',             // 선택된 버튼은 텍스트 색상 변경
                        // border: '1px solid #FE531F',
                        border:'none',
                        // borderRadius: '3px',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        fontFamily: 'Pretendard, sans-serif',
                        fontWeight: 700,
                        fontSize: '1.2vw',
                        flexShrink: 0,
                        margin: "5px 10px 0px 0px",
                        marginRight: index === productCategories.length - 1 ? '0' : '17px'
                    }}
                >
                    {category}
                </button>
            ))}
        </div>
    );
};

export default BrandsCategoryButtons2;
